import { render, staticRenderFns } from "./SendSafetyConfirmToOtherUserConfirm.vue?vue&type=template&id=6cea6aca&lang=pug"
import script from "./SendSafetyConfirmToOtherUserConfirm.vue?vue&type=script&lang=ts"
export * from "./SendSafetyConfirmToOtherUserConfirm.vue?vue&type=script&lang=ts"
import style0 from "./SendSafetyConfirmToOtherUserConfirm.vue?vue&type=style&index=0&id=6cea6aca&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports